import { ComponentProps } from "react";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { UrlInput } from "@remo-co/ui-core/src/components/UrlInput";
import { Field } from "react-final-form";
import { useI18n } from "i18n";

type Props = {
  isUrl?: boolean;
  name: string;
} & ComponentProps<typeof Input>;

const identity = (value: string) => value;

const ProfileInput = (props: Props): JSX.Element => {
  const { name, isUrl, value: _, ...rest } = props;
  const { t } = useI18n(["common"]);

  return (
    <Field parse={identity} name={name}>
      {({ input }) =>
        isUrl ? (
          <Container size="xs">
            <UrlInput
              fullWidth
              {...input}
              {...rest}
              type="text"
              errorMessage={t("incorrect.url.message")}
            />
          </Container>
        ) : (
          <Container size="xs" fullWidth>
            <Input fullWidth size="sm" {...input} {...rest} type="text" />
          </Container>
        )
      }
    </Field>
  );
};

export default ProfileInput;
